import React, { ReactElement } from "react";
import Loader from "./Loader";

const FullPageLoader = (): ReactElement => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Loader />
    </div>
  );
};

export default FullPageLoader;
